import { SectionAlert, Txt } from '@vst/beam';
import { CalendarToday } from '@vst/beam-icons/icons';
import { useTranslation } from 'react-i18next';

import { Container } from '@app/components/Container';
import { SuccessOutcome } from '@app/components/ScheduleInstallation';

type ConfirmationWithEquipmentChangeProps = {
  goToOverview: () => void;
  content: string;
};

const ConfirmationWithEquipmentChange = ({ goToOverview, content }: ConfirmationWithEquipmentChangeProps) => {
  const { t } = useTranslation('ChangePlan', {
    keyPrefix: 'orderConfirmation.withEquipmentChange',
  });

  return (
    <Container mt="56px">
      <SuccessOutcome goToOverview={goToOverview}>
        <Txt data-cy="appointment-scheduled-title" mt="48px" variant="heading4">
          {t('title')}
        </Txt>

        <Txt variant="bodyLargeRegular" mt="12px" mb="40px">
          {t('description')}
        </Txt>

        <SectionAlert
          data-cy="appointment-scheduled-SectionAlert"
          variant="infoPrimary"
          mb="40px"
          contentSlot={
            <div style={{ textAlign: 'left' }}>
              <Txt color="regular" component="span" variant="smallBold">
                {t('alertTitle')}
              </Txt>
              <Txt color="regular" component="span" variant="smallRegular">
                {content}
              </Txt>
            </div>
          }
          icon={CalendarToday}
        />
      </SuccessOutcome>
    </Container>
  );
};

export default ConfirmationWithEquipmentChange;
